import apiClient from '../../../lib/axios';

export const fetchRepositories = async ({ page = 1, pageSize = 10, isActive, search } = {}) => {
  const params = new URLSearchParams();
  params.append('page', page);
  params.append('limit', pageSize);
  if (typeof isActive === 'boolean') params.append('isActive', isActive);
  if (search) params.append('search', search);
  const { data } = await apiClient.get(`/api/repositories?${params.toString()}`);
  return data;
};

export const fetchActiveRepositories = async () => {
  const { data } = await apiClient.get('/api/repositories/active');
  return data;
};

export const fetchRepositoryById = async (id) => {
  const { data } = await apiClient.get(`/api/repositories/${id}`);
  return data;
};

export const createRepository = async (payload) => {
  const { data } = await apiClient.post('/api/repositories', payload);
  return data;
};

export const updateRepository = async ({ id, payload }) => {
  const { data } = await apiClient.patch(`/api/repositories/${id}`, payload);
  return data;
};

export const deleteRepository = async (id) => {
  const { data } = await apiClient.delete(`/api/repositories/${id}`);
  return data;
};

export default fetchRepositories;
